import { Col, Flex, Row, Typography } from "antd";

type RobinPageProps = {
  title?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
};

function RobinPage({ title, actions, children }: RobinPageProps) {
  return (
    <Row>
      <Col span={12}>
        <Typography.Title>{title}</Typography.Title>
      </Col>
      <Col span={12}>
        <Flex style={{ height: "100%" }} align="center" justify="flex-end">
          {actions}
        </Flex>
      </Col>
      <Col span={24}>{children}</Col>
    </Row>
  );
}

export default RobinPage;
